export default {
  size: {
    extraSmall: '1.2rem',
    small: '1.4rem',
    medium: '1.6rem',
    large: '2rem',
    extraLarge: '4rem'
  }
};
